/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Media_Progress_In_ProgressInputs */

const en_new_project_media_progress_in_progress = /** @type {(inputs: New_Project_Media_Progress_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Progress...`)
};

const fr_new_project_media_progress_in_progress = /** @type {(inputs: New_Project_Media_Progress_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cours...`)
};

const de_new_project_media_progress_in_progress = /** @type {(inputs: New_Project_Media_Progress_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Gange...`)
};

const it_new_project_media_progress_in_progress = /** @type {(inputs: New_Project_Media_Progress_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In corso...`)
};

const ru_new_project_media_progress_in_progress = /** @type {(inputs: New_Project_Media_Progress_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В ходе выполнения...`)
};

const es_new_project_media_progress_in_progress = /** @type {(inputs: New_Project_Media_Progress_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En curso...`)
};

const zh_cn2_new_project_media_progress_in_progress = /** @type {(inputs: New_Project_Media_Progress_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进行中...`)
};

const ja_new_project_media_progress_in_progress = /** @type {(inputs: New_Project_Media_Progress_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`進行中...`)
};

const hi_new_project_media_progress_in_progress = /** @type {(inputs: New_Project_Media_Progress_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रगति पर है...`)
};

const pt_pt2_new_project_media_progress_in_progress = /** @type {(inputs: New_Project_Media_Progress_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em andamento...`)
};

/**
* | output |
* | --- |
* | "In Progress..." |
*
* @param {New_Project_Media_Progress_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_media_progress_in_progress = /** @type {((inputs?: New_Project_Media_Progress_In_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Media_Progress_In_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_media_progress_in_progress(inputs)
	if (locale === "de") return de_new_project_media_progress_in_progress(inputs)
	if (locale === "it") return it_new_project_media_progress_in_progress(inputs)
	if (locale === "ru") return ru_new_project_media_progress_in_progress(inputs)
	if (locale === "es") return es_new_project_media_progress_in_progress(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_media_progress_in_progress(inputs)
	if (locale === "ja") return ja_new_project_media_progress_in_progress(inputs)
	if (locale === "hi") return hi_new_project_media_progress_in_progress(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_media_progress_in_progress(inputs)
	return en_new_project_media_progress_in_progress(inputs)
});